
import classNames from 'classnames';
import React from 'react';
import iconMap from './IconMapping';
import PropTypes from 'prop-types';
import { IconSize } from './Icon.type';

const Icon = ({
	dataTestId = 'icon',
	name,
	style,
	size,
	color = '#60636b',
	disabled = false,
	selected = false
}) => {
	const iconClass = classNames({
		DS__icon: true,
		'DS__icon--small': size === IconSize.SMALL,
		'DS__icon--medium': size === IconSize.MEDIUM,
		'DS__icon--large': size === IconSize.LARGE,
		'DS__icon--xlarge': size === IconSize.XLARGE, //Do not use this unless the icon size is 240x240
		'DS__icon--selected': selected,
		'DS__icon--disabled': disabled
	});

	const iconStyle = {
		color
	};

	const IconComponent = iconMap[name]?.[style];

	if (!IconComponent) {
		return null;
	}

	return (
		<div className={iconClass} style={iconStyle} data-testid={dataTestId}>
			<IconComponent />
		</div>
	);
};

Icon.propTypes = {
	dataTestId: PropTypes.string,
	name: PropTypes.string.isRequired,
	style: PropTypes.string.isRequired,
	size: PropTypes.oneOf(['small', 'medium', 'large', 'xlarge']),
	color: PropTypes.string,
	disabled: PropTypes.bool,
	selected: PropTypes.bool
};

export default Icon;
